import { render, staticRenderFns } from "./PaymentSelecter.vue?vue&type=template&id=0f4795c2&"
import script from "./PaymentSelecter.vue?vue&type=script&lang=js&"
export * from "./PaymentSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports